import React, { Component } from "react";
import { Icon, Menu, Responsive } from "semantic-ui-react";

export default class HeaderMenu extends Component {
  constructor() {
    super();
    this.state = {
      visible: true,
      activeItem: "home"
    };
  }

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name });
    console.log(this.state);
  };

  handleItemClickMobile = (e, { name }) => {
    this.setState({ activeItem: name });
    console.log(this.state);
    this.toggleVisibility();
  };

  toggleVisibility = () => {
    this.setState({ visible: !this.state.visible });
    console.log(this.state);
  };

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          <Menu size="large" inverted fixed="top" className="main_header">
            <Menu.Item onClick={this.toggleVisibility}>
              <Icon name="content" />
              &nbsp;Menü
            </Menu.Item>
          </Menu>
          {!this.state.visible && (
            <Menu
              size="large"
              inverted
              fixed="top"
              className="main_header"
              stackable
            >
              <Menu.Item
                name="Home"
                active={this.props.activeItem === "home"}
                onClick={this.handleItemClickMobile}
                href="/#Home"
              />
              <Menu.Item
                name="Service"
                active={this.props.activeItem === "service"}
                onClick={this.handleItemClickMobile}
                href="/#service"
              />
              <Menu.Item
                name="Mittellauf"
                active={this.props.activeItem === "Mittellauf"}
                onClick={this.handleItemClickMobile}
                href="/#Mittellauf"
              />
              <Menu.Item
                name="Oberlauf"
                active={this.props.activeItem === "Oberlauf"}
                onClick={this.handleItemClickMobile}
                href="/#Oberlauf"
              />
              {/*<Menu.Item name='Tour100' active={this.props.activeItem === 'Tour100'} onClick={this.handleItemClickMobile}*/}
              {/*href='/#Tour100'/>*/}
              <Menu.Item
                name="Boote"
                active={this.props.activeItem === "Leihboote"}
                onClick={this.handleItemClickMobile}
                href="/#Leihboote"
              />
              <Menu.Item
                name="Guiding"
                active={this.props.activeItem === "Guiding"}
                onClick={this.handleItemClickMobile}
                href="/#Guiding"
              />
              {/*<Menu.Item name='Team' active={this.props.activeItem === 'Team'} onClick={this.handleItemClickMobile}*/}
              {/*href='/#Team'/>*/}
              <Menu.Item
                name="Preise"
                active={this.props.activeItem === "Preise"}
                onClick={this.handleItemClickMobile}
                href="/#Preise"
              />
              <Menu.Item
                name="Events"
                active={this.props.activeItem === "Events"}
                onClick={this.handleItemClickMobile}
                href="/#Events"
              />
              <Menu.Item
                name="Kontakt"
                active={this.props.activeItem === "Kontakt"}
                onClick={this.handleItemClickMobile}
                href="/kontakt"
              />
            </Menu>
          )}
        </Responsive>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Menu
            size="large"
            inverted
            fixed="top"
            className="main_header"
            stackable
          >
            <Menu.Item
              name="Home"
              active={this.props.activeItem === "home"}
              onClick={this.handleItemClick}
              href="/#Home"
            />
            <Menu.Item
              name="Service"
              active={this.props.activeItem === "service"}
              onClick={this.handleItemClick}
              href="/#service"
            />
            <Menu.Item
              name="Mittellauf"
              active={this.props.activeItem === "Mittellauf"}
              onClick={this.handleItemClick}
              href="/#Mittellauf"
            />
            <Menu.Item
              name="Oberlauf"
              active={this.props.activeItem === "Oberlauf"}
              onClick={this.handleItemClick}
              href="/#Oberlauf"
            />
            {/*<Menu.Item name='Tour100' active={this.props.activeItem === 'Tour100'} onClick={this.handleItemClick}*/}
            {/*href='/#Tour100'/>*/}
            <Menu.Item
              name="Boote"
              active={this.props.activeItem === "Leihboote"}
              onClick={this.handleItemClick}
              href="/#Leihboote"
            />
            <Menu.Item
              name="Guiding"
              active={this.props.activeItem === "Guiding"}
              onClick={this.handleItemClick}
              href="/#Guiding"
            />
            {/*<Menu.Item name='Team' active={this.props.activeItem === 'Team'} onClick={this.handleItemClick}*/}
            {/*href='/#Team'/>*/}
            <Menu.Item
              name="Preise"
              active={this.props.activeItem === "Preise"}
              onClick={this.handleItemClickMobile}
              href="/#Preise"
            />
            <Menu.Item
              name="Events"
              active={this.props.activeItem === "Events"}
              onClick={this.handleItemClickMobile}
              href="/#Events"
            />
            <Menu.Item
              name="Kontakt"
              active={this.props.activeItem === "Kontakt"}
              onClick={this.handleItemClickMobile}
              href="/kontakt"
            />
          </Menu>
        </Responsive>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js